module.exports = __webpack_public_path__ + "static/media/ih-logo-640x196-on-light.9dcfc76f.png";